import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { playoffTableImageBlob } from "../utils/playoffTableImage";

const PlayoffTableImageCopyButton = ({ imageOptions, fileName, disabled = false }) => {
    const [state, setState] = useState("idle");

    useEffect(() => {
        if (state !== "copied") return undefined;
        const timeout = window.setTimeout(() => setState("idle"), 3000);
        return () => window.clearTimeout(timeout);
    }, [state]);

    const download = (blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${fileName}.png`;
        link.click();
        URL.revokeObjectURL(url);
    };

    const copyImage = async () => {
        if (disabled || state === "working") return;
        setState("working");
        try {
            const blob = await playoffTableImageBlob(imageOptions);
            const file = new File([blob], `${fileName}.png`, { type: "image/png" });
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            );

            if (isMobile && navigator.share && navigator.canShare?.({ files: [file] })) {
                await navigator.share({ files: [file] });
            } else if (navigator.clipboard && window.ClipboardItem) {
                try {
                    await navigator.clipboard.write([
                        new window.ClipboardItem({ "image/png": blob }),
                    ]);
                } catch (error) {
                    console.warn("Clipboard write failed; downloading table image instead.", error);
                    download(blob);
                }
            } else {
                download(blob);
            }
            setState("copied");
        } catch (error) {
            console.error("Error copying playoff table as image:", error);
            setState("idle");
        }
    };

    return (
        <button
            type="button"
            className={`copy-btn ${state === "copied" ? "copy-success" : ""}`}
            disabled={disabled || state === "working"}
            onClick={copyImage}
            title="Copy the complete table as an image"
        >
            {state === "working" ? "⏳ Processing..." : state === "copied" ? "✅ Copied!" : "📋 Copy as Image"}
        </button>
    );
};

PlayoffTableImageCopyButton.propTypes = {
    imageOptions: PropTypes.object.isRequired,
    fileName: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

export default PlayoffTableImageCopyButton;
